module.exports = __webpack_public_path__ + "static/img/StateDeptLogo-Sm.f35c2cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/StateDeptLogo-Sm.png
// module id = axf+
// module chunks = 1